module.exports = __webpack_public_path__ + "img/soluzionismartbuildings.b46fca96.png";